import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Slider from '@mui/material/Slider';
import { radiusAction } from './actions';
import { useSelector, useDispatch } from 'react-redux';
export default function MapRadius() {
    var SiteData = useSelector(state => state.SiteData);
    const radius = useSelector(state => state.MadRadius);
    var dispatch = useDispatch();
    const handleSliderChange = ( e ) => {
        var value = e.target.value * 70;// x 70 means to stabilize slider
        dispatch(radiusAction(value * 1000));// x1000 means convert to meter
    };
    const valueLabelFormat = () => {
        var radius_label = SiteData.label_radius ? SiteData.label_radius : 'Radius';
        return `${radius_label} ${radius / 1000} KM`;
    }
    return (
    <Box className="rslRadiusSLider" sx={{ width: 250 }}>
        <Typography id="input-slider" gutterBottom>{SiteData.label_distance_range ? SiteData.label_distance_range : 'Distance Range'}</Typography>
        <Grid container spacing={2} alignItems="center">
            <Grid item xs>
                <Slider onChange={handleSliderChange} value={radius/70000}
                getAriaValueText={valueLabelFormat} valueLabelFormat={valueLabelFormat} color="secondary"
                valueLabelDisplay="auto" aria-labelledby="non-linear-slider" min={0} max={100} />
            </Grid>
        </Grid>
    </Box>
    );
}